import { Vue, Component } from 'vue-property-decorator'
import SearchProduct from './searchProduct'
import { Functions } from '@/library/utils/functions'
import { IPSService } from '@/services/ipsServices'

@Component

export default class LiveVideo extends Vue {
    liveRoomId = ''
    goodsId = ''
    videoAddress = ''
    siteId = 0

    mounted() {
        this.siteId = +this.$route.params.siteId
    }
    getVideoUrl() {
        if (!this.liveRoomId || !this.goodsId) {
            this.$message.error('请输入直播房间号和商品ID')
            return
        }
        const postParams = {
            roomId: +this.liveRoomId,
            goodsId: this.goodsId,
            siteId: this.siteId
        }
        IPSService.liveDownloadProductView({ postParams }).then((res) => {
            this.videoAddress = res.url
        }).catch((error) => {

        })

    }
    onSearch() {
        SearchProduct.open({ siteId: this.siteId }).then((res) => {
            this.goodsId = res
        })
    }
    onCopy() {
        Functions.clickCopy(this.videoAddress, '链接拷贝成功')
    }
    render() {
        return (
            <div class="formWrapper">
                <el-form props={{ model: {} }} label-position="left" label-width="120px" class="r-px-30 r-pt-2 overflow-auto" ref="form" style="height:calc(100% - 54px)">
                    <div class="formItemWrapper">
                        <div class="blockTitle">直播视频拉取</div>
                        <p class="tip blockTip line-height-24 r-mb-20">注：请输入小程序直播的房间号（请从小程序后台直播间中获取）及商品ID，以获取该商品在直播中的相关视频。</p>
                        <el-form-item label="直播房间号">
                            <el-input v-model={this.liveRoomId} class="wid-80" />
                        </el-form-item>
                        <el-form-item label="商品ID">
                            <div class="flex-inline items-center hei-16">
                                <div class="flex-inline items-center hei-16 relative-position fl">
                                    <el-input v-model={this.goodsId} class="wid-80" />
                                    <i class="wid-15 hei-15 top-12 line-height-8 font-size-18 text-blue-15 absolute right-0 cursor-pointer iconfont iconsousuo" onClick={() => this.onSearch()}></i>
                                </div>
                                <el-button class="r-ml-14" type="primary" onClick={() => { this.getVideoUrl() }}>获取视频地址</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="视频地址">
                            <el-input v-model={this.videoAddress} disabled class="wid-300" />
                            <span class="scopeSpan r-ml-14" onClick={() => this.onCopy()}>拷贝</span>
                        </el-form-item>

                    </div>
                </el-form>
            </div>
        )

    }
}